
import { UseFormRegister, UseFormSetValue, UseFormGetValues } from 'react-hook-form';
import { EmployeeCountFields } from './fields/EmployeeCountFields';
import { StatesServedField } from './fields/StatesServedField';
import { YearsInBusinessField } from './fields/YearsInBusinessField';
import type { FormData } from './types';

interface VerifiedInformationProps {
  register: UseFormRegister<FormData>;
  setValue: UseFormSetValue<FormData>;
  getValues: UseFormGetValues<FormData>;
}

export const VerifiedInformation = ({ register, setValue, getValues }: VerifiedInformationProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Verified Information</h3>
      <p className="text-sm text-muted-foreground mb-4">
        Only fill out these fields if the information has been verified with documentation.
      </p>
      
      <div className="grid gap-4">
        <EmployeeCountFields register={register} />
        <StatesServedField register={register} setValue={setValue} getValues={getValues} />
        <YearsInBusinessField register={register} />
      </div>
    </div>
  );
};
